import { ArrowLeftOutlined } from "@ant-design/icons";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchPortfolioMappers,
  fetchPortfolioMaster,
  updatePortfolioMapHeaders,
  updatePortfolioMasterHeaders,
} from "../../../assets/api/portfolio";
import CustomNotification from "../../../Reuseable/CustomNotification/CustomNotification";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import CustomSelect from "../../../Reuseable/Select/Select";
import "./PortfolioEditMap.scss";

const fieldConfigMap = {
  // Agency
  // "Agency ID": "agency_id",

  // Loan Details
  "Loan no.": "LOAN_NO",
  "App ID": "APP_ID",
  EMI: "LOAN_EMI",
  "Amount Overdue": "AMOUNT_OVERDUE",
  ODPOS: "ODPOS",
  "Bounce Charges": "BOUNCE_CHARGES",
  "Overdue Charges": "OVERDUE_CHARGES",
  "Other Charges": "OTHER_CHARGES",
  "Total Amount Due": "TOTAL_AMOUNT_DUE",
  // "TOT INST OS": "TOT_INST_OS",
  DPD: "DPD",
  Bucket: "BUCKET",
  "TOT PRIN OS": "TOT_PRIN_OS",
  Tenure: "TENURE",
  "Disbursal Date": "DISBURSAL_DATE",
  "Disbursal Amount": "DISBURSAL_AMOUNT",
  "Bounce Reason": "BOUNCE_REASON",
  "Bounce Date": "BOUNCE_DATE",
  "Maturity Date": "MATURITY_DATE",
  "Mode Repayment": "MODE_REPAYMENT",
  Product: "PRODUCT",

  // Customer Details
  "Customer Id": "CUSTOMER_ID",
  "Customer Name": "CUSTOMER_NAME",
  DOB: "DOB",
  Age: "AGE",
  Gender: "GENDER",
  "Customer Type": "CUST_TYPE",
  "Pan No.": "PAN_NO",
  "Aadhar Card No": "AADHAR_CARD_NO",
  "Passport No": "PASSPORT_NO",
  "Voter ID No": "VOTER_ID_NO",
  "PAN Card No": "PAN_CARD_NO",
  "Marital Status": "MARITAL_STATUS",
  Occupation: "OCCUPATION",

  // Main Address (ADDRESS_1 to 10)
  "Permanent Address": "PERMANENT_ADDRESS",
  "Current Address": "CURRENT_ADDRESS",
  "Office Address": "OFFICE_ADDRESS",
  City: "CITY",

  // "Address 1": "ADDRESS_1",
  // "Address 2": "ADDRESS_2",
  // "Address 3": "ADDRESS_3",
  // "Address 4": "ADDRESS_4",
  // "Address 5": "ADDRESS_5",
  // "Address 6": "ADDRESS_6",
  // "Address 7": "ADDRESS_7",
  // "Address 8": "ADDRESS_8",
  // "Address 9": "ADDRESS_9",
  // "Address 10": "ADDRESS_10",

  // Customer Mailing
  // "Customer Mailing Address 1": "CUST_MAILING_ADDR1",
  // "Customer Mailing Address 2": "CUST_MAILING_ADDR2",
  // "Customer Mailing Address 3": "CUST_MAILING_ADDR3",
  // "Customer Mailing Address 4": "CUST_MAILING_ADDR4",
  // "Customer Mailing City": "CUST_MAILING_CITY",
  // "Customer Mailing PIN": "CUST_MAILING_PIN",
  // "Customer Mailing Phone 1": "CUST_MAILING_PHONE1",
  // "Customer Mailing Phone 2": "CUST_MAILING_PHONE2",
  "Customer Mobile No": "CUST_MOBILE_NO",

  // Customer Alternate Address
  // "Customer Alt. Address 1": "CUST_ALT_ADDR1",
  // "Customer Alt. Address 2": "CUST_ALT_ADDR2",
  // "Customer Alt. Address 3": "CUST_ALT_ADDR3",
  // "Customer Alt. Address 4": "CUST_ALT_ADDR4",
  // "Customer Alt. City": "CUST_ALT_CITY",
  // "Customer Alt. Pin": "CUST_ALT_PIN",
  // "Customer Alt. Phone 1": "CUST_ALT_PHONE1",
  // "Customer Alt. Phone 2": "CUST_ALT_PHONE2",
  // "Customer Alt. Mobile no.": "CUST_ALT_MOBILE",

  // Phones
  "Phone Number 1": "PHONE_NUMBER_1",
  "Phone Number 2": "PHONE_NUMBER_2",
  // "Phone Number 3": "PHONE_NUMBER_3",
  // "Phone Number 4": "PHONE_NUMBER_4",
  // "Phone Number 5": "PHONE_NUMBER_5",
  // "Phone Number 6": "PHONE_NUMBER_6",
  // "Phone Number 7": "PHONE_NUMBER_7",
  // "Phone Number 8": "PHONE_NUMBER_8",
  // "Phone Number 9": "PHONE_NUMBER_9",
  // "Phone Number 10": "PHONE_NUMBER_10",

  // Co-Applicant
  "Co Applicant Name": "COAPP_NAME",
  "Co Applicant Address 1": "COAPP_ADDR1",
  // "Co Applicant Address 2": "COAPP_ADDR2",
  // "Co Applicant Address 3": "COAPP_ADDR3",
  // "Co Applicant Address 4": "COAPP_ADDR4",
  "Co Applicant City": "COAPP_CITY",
  "Co Applicant PIN": "COAPP_PIN",
  "Co Applicant Phone 1": "COAPP_PHONE1",
  "Co Applicant Phone 2": "COAPP_PHONE2",
  // "Co Applicant Mobile no.": "COAPP_MOBILE",

  // Employer
  "Employer Name": "EMPLOYER_NAME",
  "Employer Address 1": "EMP_ADDR1",
  // "Employer Address 2": "EMP_ADDR2",
  // "Employer Address 3": "EMP_ADDR3",
  // "Employer Address 4": "EMP_ADDR4",
  "Employer City": "EMP_CITY",
  "Employer PIN": "EMP_PIN",
  "Employer Phone 1": "EMP_PHONE1",
  "Employer Phone 2": "EMP_PHONE2",
  // "Employer Mobile": "EMP_MOBILE",
  "Employer Type": "EMPLOYER_TYPE",

  // Asset
  "Asset Description": "ASSET_DESC",
  Make: "MAKE",
  Model: "MODEL",
  "Engine No.": "ENGINE_NO",
  "Chassis No.": "CHASSIS_NO",
  "Reg. No": "REG_NO",

  // Branch & Dealer
  "Dealer Name": "DEALER_NAME",
  "DMA Name": "DMA_NAME",
  "Branch Name": "BRANCH_NAME",

  // Dates & Status
  "Due Date": "DUE_DATE",
  "EMI Start Date": "EMI_START_DATE",
  "Last Due Date": "LAST_DUE_DATE",
  "Last Contacted On": "LAST_CONTACTED_ON",
  "Last Contacted Date": "LAST_CONTACTED_DATE",
  // "Broken Settlement": "BROKEN_SETTLEMENT",
  // "Settlement Rejected": "SETT_REJECTED",
  // "Settlement Approved Nil Payment": "SETT_APPROVED_NIL_PYT",
  // "Settlement Date": "SETTLEMENT_DATE",
  // "Settlement Amount": "SETTLEMENT_AMOUNT",

  // Linked Accounts
  // "Link Account 1": "LINK_ACCT_1",
  // "Link Account 2": "LINK_ACCT_2",
  // "Link Account 3": "LINK_ACCT_3",
  // "Link Account 4": "LINK_ACCT_4",
  // "Link Account 5": "LINK_ACCT_5",

  // Case Details
  "Case Type": "CASE_TYPE",
  "Case Stage": "CASE_STAGE",
  "Case No": "CASE_NO",
  // "Case Category By": "CASE_CATEGORY_BY",
  // "Case Category Against": "CASE_CATEGORY_AGAINST",

  // Others
  Profile: "PROFILE",
  State: "STATE",
  Region: "REGION",
  // "Contact No From Eclass": "CONTACT_NO_FROM_ECLASS",
  "Installment Amount": "INSTALLMENT_AMOUNT",
  "Installment Date": "INSTALLMENT_DATE",

  // Reference Contacts
  "Reference Name 1": "REFERENCE_NAME_1",
  "Reference Name 1 Phone Number": "REFERENCE_NAME_1_PHONE_NUMBER",
  "Reference Name 2": "REFERENCE_NAME_2",
  "Reference Name 2 Phone Number": "REFERENCE_NAME_2_PHONE_NUMBER",
  "Reference Relation 1": "REFERENCE_RELATION_1",
  "Reference Name 1 Address": "REFERENCE_NAME_1_ADDRESS",
  "Reference Relation 2": "REFERENCE_RELATION_2",
  "Reference Name 2 Address": "REFERENCE_NAME_2_ADDRESS",
  LTV: "LTV",
};

const fieldLabels = Object.keys(fieldConfigMap);

// const requiredFields = [
//   "EMI", "Amount Overdue", "ODPOS", "Bounce Charges", "TOT INST OS", "TOT PRIN OS", "DPD", "Customer Name", "Asset Description", "Customer Mobile No", "State", "Region", "Disbursal Date", 'Address 1', 'Product', "Customer Id", "Loan no.", "App ID", "Branch Name", "Customer Mailing City", "Permanent Address", "Current Address", "Office Address", "City"
// ]

// updated requiredFields
const requiredFields = [
  "EMI",
  "Amount Overdue",
  "ODPOS",
  "Bounce Charges",
  "TOT PRIN OS",
  "DPD",
  "Customer Name",
  "Asset Description",
  "Customer Mobile No",
  "State",
  "Region",
  "Disbursal Date",
  "Product",
  "Customer Id",
  "Loan no.",
  "App ID",
  "Branch Name",
  "Permanent Address",
  "Current Address",
  "Office Address",
  "City",
];

const PortfolioEditMap = ({ onBack }) => {
  const { id } = useParams();
  const { token } = useSelector((state) => state.auth);
  const [mappedHeaders, setMappedHeaders] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [disabledOptions, setDisabledOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectToConfig = queryParams.get("redirectFromConfig") == "true";
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const getMappers = async () => {
      try {
        const res = await fetchPortfolioMappers(state?.id, token);
        const headers = res?.data?.data?.headers || [];
        const preselected = res?.data?.data?.mappedHeaders || {};

        setMappedHeaders(headers);
        setSelectedValues(preselected);

        // Update disabled options initially
        setDisabledOptions(Object.values(preselected));
      } catch (error) {
        console.error("Error fetching mappers", error);
      }
    };
    if (!redirectToConfig) {
      getMappers();
    } else {
      getMappers();
      getMasterHeader();
    }
  }, [state, token]);

  const getMasterHeader = async () => {
    try {
      const res = await fetchPortfolioMaster(state?.id, token);
      const headers = res?.data?.data;
      const fields = headers?.available_fields || [];

      // const fieldsName = fields.map((item) => item.field_name);
      // setMappedHeaders(fieldsName);

      fields.forEach((field) => {
        const upperFieldName = field.field_name?.toUpperCase();
        const value = field.current_value;
        const label = Object.keys(fieldConfigMap).find(
          (key) =>
            fieldConfigMap[key] === upperFieldName &&
            value != null &&
            value != "",
        );

        if (label) {
          handleSelectChange(label, value);
        }
      });
    } catch (error) {
      console.error("Error fetching mappers", error);
    }
  };

  // New Updated handleSelectChange
  const handleSelectChange = (label, selected) => {
    const key = fieldConfigMap[label];

    // console.log(`\n--- Loop iterate over field : ${label} (Key: ${key}) ---`);
    // console.log(label, selected, "adfasdf");
    // console.log(label, "adfasdf");

    // console.log("Outer Stale Snapshot (selectedValues):", Object.keys(selectedValues));

    // Set form value directly
    form.setFieldsValue({ [key]: selected });

    setSelectedValues((prevSelections) => {
      // console.log("Fresh React Queue State (prevSelections):", Object.keys(prevSelections));
      const updatedSelections = {
        ...prevSelections,
        [key]: selected,
      };
      setDisabledOptions(Object.values(updatedSelections));
      return updatedSelections;
    });
  };

  // console.log(selectedValues, "selectedValuess");

  const getDisabledOptions = (currentLabel) => {
    return new Set(
      Object.entries(selectedValues)
        .filter(([key]) => key !== fieldConfigMap[currentLabel])
        .map(([, value]) => value),
    );
  };

  const handleSave = async () => {
    try {
      await form.validateFields();

      setLoading(true);
      if (!redirectToConfig)
        await updatePortfolioMapHeaders(state?.id, selectedValues, token);
      else await updatePortfolioMasterHeaders(state?.id, selectedValues, token);

      CustomNotification.show("Headers mapped successfully.", "success");
      navigate("/portfolio");
    } catch (err) {
      console.error(err);
      CustomNotification.show("Failed to map headers.", "error");
    } finally {
      setLoading(false);
    }
  };

  const [form] = Form.useForm();

  return (
    <div className="portfolioEditMapMain">
      <div className="editMapHeader">
        <button className="backButton" onClick={handleBack}>
          <ArrowLeftOutlined style={{ marginRight: 8 }} />
        </button>
        <h2>Edit Map Headers</h2>
      </div>

      <Form form={form} layout="vertical">
        <div className="selectorWrapper">
          {fieldLabels.map((label, index) => {
            const selectedKey = fieldConfigMap[label];
            const isRequired = requiredFields.includes(label);

            const optionsList = mappedHeaders.map((item) => ({
              label: item,
              value: item,
              // disabled: disabledSet.has(item),
            }));

            return (
              <Form.Item
                key={index}
                name={selectedKey}
                required={requiredFields.includes(label)?.length > 0}
                rules={
                  requiredFields.includes(label)
                    ? [{ required: true, message: `Please select ${label}` }]
                    : []
                }
              >
                <CustomSelect
                  key={index}
                  className="formSelect"
                  placeholder="Select Header"
                  options={optionsList}
                  label={
                    isRequired ? (
                      <span>
                        <span style={{ color: "#ff4d4f", marginRight: "4px" }}>
                          *
                        </span>
                        {label}
                      </span>
                    ) : (
                      label
                    )
                  }
                  showSearch={true}
                  value={
                    selectedValues[selectedKey]
                      ? [selectedValues[selectedKey]]
                      : []
                  }
                  onChange={(value) => handleSelectChange(label, value)}
                />
              </Form.Item>
            );
          })}
        </div>
      </Form>

      <NormalButton onClick={handleSave} loading={loading}>
        Save Changes
      </NormalButton>
    </div>
  );
};

export default PortfolioEditMap;
